import {BaseCurrencyCode} from './BaseCurrencyCode';

export type CryptoCurrencyCode = BaseCurrencyCode;
export const CryptoCurrencyCode = BaseCurrencyCode;
